'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addProduct = addProduct;
exports.deleteProduct = deleteProduct;
exports.changeCountProduct = changeCountProduct;
exports.clearBasket = clearBasket;
exports.createOrder = createOrder;
exports.basketFromLocalStorage = basketFromLocalStorage;
exports.shareBasket = shareBasket;
exports.getSharedBasket = getSharedBasket;
exports.resetShareCode = resetShareCode;
exports.changeShareState = changeShareState;
exports.getActualPrices = getActualPrices;
exports.addCouponInBasket = addCouponInBasket;
exports.editOrder = editOrder;
exports.postponeBasket = postponeBasket;
exports.getPostpone = getPostpone;
exports.deletePostpone = deletePostpone;
exports.mergePostpone = mergePostpone;

var _constants = require('redux/constants');

function addProduct(product) {
    return {
        type: _constants.BasketConstants.ADD_BASKET,
        product: product
    };
}

function deleteProduct(id) {
    var modifier_option_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var key = arguments[2];

    return {
        type: _constants.BasketConstants.REMOVE_BASKET,
        id: id,
        modifier_option_id: modifier_option_id,
        keyArray: key
    };
}

function changeCountProduct(id, count) {
    var modifier_option_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return {
        type: _constants.BasketConstants.CHANGE_COUNT_PRODUCT_IN_BASKET,
        id: id,
        count: count,
        modifier_option_id: modifier_option_id,
        keyArray: key
    };
}

function clearBasket() {
    return {
        type: _constants.BasketConstants.CLEAR_BASKET
    };
}

function createOrder(_ref) {
    var sum = _ref.sum,
        products = _ref.products,
        userAgent = _ref.userAgent,
        utmRedirectData = _ref.utmRedirectData,
        currency_id = _ref.currency_id,
        delivery_address = _ref.delivery_address,
        customFields = _ref.customFields;

    return {
        types: [_constants.BasketConstants.ORDER_LOAD, _constants.BasketConstants.ORDER_LOAD_SUCCESS, _constants.BasketConstants.ORDER_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.orderCreate(sum, products, userAgent, utmRedirectData, currency_id, delivery_address, customFields).then(function (result) {
                return {
                    result: result
                };
            });
        }
    };
}

function basketFromLocalStorage() {
    return {
        type: _constants.BasketConstants.COPY_TO_BASKET
    };
}

function shareBasket() {
    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var customFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var arr = basketElements;

    return {
        types: [_constants.BasketConstants.SHARE_BASKET_LOAD, _constants.BasketConstants.SHARE_BASKET_SUCCESS, _constants.BasketConstants.SHARE_BASKET_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.shareBasket(arr, customFields).then(function (result) {
                return result;
            });
        }
    };
}

function getSharedBasket(code) {
    return {
        types: [_constants.BasketConstants.GET_SHARE_BASKET_LOAD, _constants.BasketConstants.GET_SHARE_BASKET_SUCCESS, _constants.BasketConstants.GET_SHARE_BASKET_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getSharedBasket(code);
        }
    };
}

function resetShareCode() {
    return {
        type: _constants.BasketConstants.BASKET_RESET_SHARE_CODE
    };
}

function changeShareState(shareState) {
    return {
        type: _constants.BasketConstants.BASKET_CHANGE_SHARE,
        payload: shareState
    };
}

function getActualPrices() {
    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return {
        types: [_constants.BasketConstants.GET_ACTUAL_PRICES_LOAD, _constants.BasketConstants.GET_ACTUAL_PRICES_SUCCESS, _constants.BasketConstants.GET_ACTUAL_PRICES_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getActualPrices(basketElements);
        }
    };
}

function addCouponInBasket(product) {
    return {
        type: _constants.BasketConstants.ADD_BASKET,
        product: product
    };
}

function editOrder(_ref2) {
    var order_id = _ref2.order_id,
        sum = _ref2.sum,
        products = _ref2.products,
        userAgent = _ref2.userAgent,
        utmRedirectData = _ref2.utmRedirectData,
        currency_id = _ref2.currency_id;

    return {
        types: [_constants.BasketConstants.ORDER_LOAD, _constants.BasketConstants.ORDER_LOAD_SUCCESS, _constants.BasketConstants.ORDER_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.editOrder(order_id, sum, products, userAgent, utmRedirectData, currency_id).then(function (result) {
                return {
                    result: result
                };
            });
        }
    };
}

function postponeBasket() {
    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var customFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var arr = basketElements;
    return {
        types: [_constants.BasketConstants.POSTPONE_BASKET_LOAD, _constants.BasketConstants.POSTPONE_BASKET_SUCCESS, _constants.BasketConstants.POSTPONE_BASKET_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.postponeBasket(arr, customFields).then(function (result) {
                return result;
            });
        }
    };
}

function getPostpone() {
    return {
        types: [_constants.BasketConstants.GET_POSTPONE_BASKET_LOAD, _constants.BasketConstants.GET_POSTPONE_BASKET_SUCCESS, _constants.BasketConstants.GET_POSTPONE_BASKET_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPostpone().then(function (result) {
                return result;
            });
        }
    };
}

function deletePostpone(id) {
    return {
        types: [_constants.BasketConstants.DELETE_POSTPONE_LOAD, _constants.BasketConstants.DELETE_POSTPONE_SUCCESS, _constants.BasketConstants.DELETE_POSTPONE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.deletePostpone(id).then(function (result) {
                return result;
            });
        }
    };
}

function mergePostpone(mergeIds) {
    return {
        types: [_constants.BasketConstants.MERGE_POSTPONE_LOAD, _constants.BasketConstants.MERGE_POSTPONE_SUCCESS, _constants.BasketConstants.MERGE_POSTPONE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.mergePostpone(mergeIds).then(function (result) {
                return result;
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/basket.js
// module id = 101
// module chunks = 0